import type {
  CreateSessionRequest,
  CreateSessionResponse,
  GetSessionResponse,
  GetStageResponse,
} from "@binogi-livequiz/shared";
import { getConfig } from "./config";

function base(): string {
  return getConfig().httpApiUrl;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly raw?: string,
  ) {
    super(message);
  }
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const baseUrl = base();
  if (!baseUrl && typeof window !== "undefined") {
    console.warn(
      "HTTP API URL is empty. Did /config.json fail to load, and is VITE_HTTP_API_URL set for local dev?",
    );
  }
  const res = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
  const text = await res.text();
  if (!res.ok) {
    throw new ApiError(res.status, text || `HTTP ${res.status}`, text);
  }
  return text ? (JSON.parse(text) as T) : ({} as T);
}

export const api = {
  createSession: (body: CreateSessionRequest) =>
    call<CreateSessionResponse>("/sessions", {
      method: "POST",
      body: JSON.stringify(body),
    }),
  getSession: (sessionCode: string) =>
    call<GetSessionResponse>(`/sessions/${encodeURIComponent(sessionCode)}`),
  getStage: (stageId: string) =>
    call<GetStageResponse>(
      `/sessions/stage/${encodeURIComponent(stageId)}`,
    ),
};
